// WMS Raporları sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'wms.reports';

export const wmsReportsGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'WMS Raporları nasıl okunur?'),
  intro: t(`${G}.intro`, 'Akıllı deponun sipariş karşılama, toplama, paketleme, mal kabul ve sayım sonuçlarını seçtiğiniz tarih aralığında gösterir. Raporlar yalnız okunur; hiçbir kaydı değiştirmez. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Depo ve tarih aralığı'),
    tabs: t(`${G}.regions.tabs`, 'Rapor sekmeleri'),
    body: t(`${G}.regions.body`, 'Rapor içeriği'),
  },
  navItems: [
    t(`${G}.nav.overview`, 'Genel Bakış'),
    t(`${G}.nav.picking`, 'Toplama'),
    t(`${G}.nav.packing`, 'Paketleme'),
    t(`${G}.nav.receiving`, 'Mal Kabul'),
    t(`${G}.nav.counting`, 'Sayım'),
  ],
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Depoyu ve tarih aralığını seçin'),
      text: t(`${G}.s1.text`, 'Depo listesinden akıllı depoyu, Başlangıç ve Bitiş ile tarih aralığını seçin; varsayılan son 7 gündür. Bitiş günü dahildir. Seçim değişince açık sekme yeniden yüklenir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Genel Bakış: sipariş karşılama'),
      text: t(`${G}.s2.text`, 'SİPARİŞ KARŞILAMA bölümü, tarih aralığında depoya gelen siparişleri sayar. Karşılanan: paketlenmiş, kargolanmış veya tamamlanmış siparişler; yanındaki yüzde karşılanan / gelen oranıdır. İptal edilen ve oranı aynı şekilde hesaplanır. Bekleyen: henüz işleme alınmamış siparişler. Ort. karşılama süresi: karşılanan siparişlerde gelişten son güncellemeye kadar geçen ortalama saat.'),
      tips: [
        t(`${G}.s2.tip1`, 'GÜNLÜK GRAFİK her gün için Gelen, Karşılanan ve İptal sayılarını çubuk olarak gösterir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Toplama'),
      text: t(`${G}.s3.text`, 'TOPLAYICI BAZLI PERFORMANS, tarih aralığında tamamlanan iş emirlerini toplayıcıya göre gruplar: iş emri sayısı, toplanan ürün adedi, iş emri başına ortalama süre (dk) ve verimlilik (saatte toplanan ürün, "ü/s"). Liste en verimli toplayıcıdan başlar. SHORT PICK RAPORU toplama sırasında eksik bildirilen ürünleri tarih, lokasyon, toplayıcı ve açıklamayla listeler (en son 100 kayıt).'),
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Paketleme ve mal kabul'),
      text: t(`${G}.s4.text`, 'Paketleme sekmesi tarih aralığında paketlenen veya kargolanan siparişleri (sipariş no, ürün adedi, tekli / çoklu, kargo, durum) ve Toplam Sipariş, Toplam Ürün, Kargolanan sayılarını gösterir. Mal Kabul sekmesi her teslimatın ürün çeşidini, toplam adedini ve rafa yerleştirilen adet ile yüzdesini listeler.'),
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Sayım doğruluğu'),
      text: t(`${G}.s5.text`, 'Sayım sekmesi tarih aralığında tamamlanan veya onaylanan sayım görevlerini listeler: lokasyon sayısı, fark sayısı ve doğruluk. Doğruluk = (lokasyon sayısı − fark sayısı) ÷ lokasyon sayısı × 100. %95 ve üstü yeşil, %80–95 sarı, altı kırmızı görünür. "Genel envanter doğruluğu" listedeki görevlerin doğruluk ortalamasıdır.'),
      tips: [
        t(`${G}.s5.tip1`, 'Farkların ayrıntısı ve stok düzeltmesi için Stok Sayım Yönetimi sayfasındaki Fark Raporu\'nu kullanın.'),
      ],
    },
  ],
});
